<template>
  <v-layout v-if="taxi" pl-2 pt-4 pr-2 pb-2 justify-center row>
    <v-flex xs12 sm10 md9 lg7 pl-2>
      <SimpleCard>
        <v-layout row wrap>
          <v-flex xs12>
            <h3>Create Taxi</h3>
          </v-flex>
          <v-flex xs12 md12>
            <TaxiForm
              ref="taxiForm"
              :disabled="false"
              :taxi="taxi"
              :errors="errors"
              :rideTypes="rideTypes"
              :councils="councils"
              @validityChange="updateFormValidity($event)"
            />
          </v-flex>
          <v-flex xs12 md12>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="submit" class="text-none">Submit</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
//TODO change directory of taxi form
import TaxiForm from "@/components/driver/TaxiForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "create_taxi",
  components: {
    SimpleCard,
    TaxiForm
  },
  data: function() {
    return {
      rideTypes: null,
      taxi: {
        registration_number: "",
        plate_number: "",
        make: "",
        model: "",
        colour: "",
        num_seats: 0,
        type: "",
        disabled_access: false,
        premium_vehicle: false,
        pets_allowed: false,
        wide: false,
        hackney_carriage: false,
        mot_valid_until: "",
        insurance_certificate_number: "",
        insurance_valid_until: "",
        compliance_certificate_expiry: "",
        road_tax_valid_until: "",
        council: "",
        ride_type_id: 0
      },
      councils: null,
      errors: {},
      formValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null
    };
  },
  mounted: function() {
    this.getRequiredInformation();
  },
  methods: {
    getRequiredInformation: async function() {
      this.loading = true;
      try {
        let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;

        let response = await axios.get(url, {
          params: {}
        });

        this.rideTypes = response.data.ride_types;
        this.councils = response.data.councils;
      } catch (error) {
        this.loading = false;
        console.log(
          "Failed to get information required to create taxi " + error
        );
      }
    },
    submit: async function() {
      let url = `${this.$store.state.apiUrl}/taxi/create`;

      if (this.formValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/taxi/create`;
        axios({
          url: url,
          method: "post",
          data: {
            taxi: this.taxi
          },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage = "Error adding taxi, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error adding taxi: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              const taxiID = response.data.taxi.id;
              self.$router.push("../taxi/edit/" + taxiID);
            }
          })
          .catch(function(error) {
            console.log(error);
            self.snackbarMessage = "Network error: " + error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.taxiForm.validateForm();
      }
    },
    updateFormValidity: function(value) {
      this.formValid = value;
    }
  }
};
</script>
